import { INSPECTION_STATUSES } from './inspectionConst';

/** 修理依頼のタイプと表示文言の紐付け */
export const TYPE: { [key: number]: string } = {
  0: 'LBL_STATUS_INSPECTION', // 受入診断
  1: 'LBL_STATUS_QC', // 出荷検査
};
/** 修理依頼のステータスと表示文言の紐付け */
export const STATUS: { [key: number]: string } = {
  0: 'LBL_IN_PROGRESS', // 進行中
  1: 'LBL_COMPLETED', // 完了
};
/** 一覧表示の1ページに表示する件数のリスト */
export const ROWS_PER_PAGE_LIST = [10, 50, 100];
/** 修理依頼検索の1ページに表示する行数のリストの初期値 */
export const DEFAULT_ROWS_PER_PAGE = ROWS_PER_PAGE_LIST[1];
/** セッションストレージのキー */
export const SESSION_STORAGE_KEY = {
  /** 修理依頼番 */
  RMA_NO: 'rmaNo',
  /** ログイン後リダイレクト先のURL */
  REDIRECT_URL: 'redirectUrl',
};
/** 役割
 * 1 : メ内サ
 * 2 : 地域管理者
 * 3 : ユーザー(一般)
 */
export const ROLE: { [key: number]: string } = {
  1: 'LBL_ROLE_ADMIN',
  2: 'LBL_ROLE_AREA_MGR',
  3: 'LBL_ROLE_USER',
};
/**
 * ユーザーの言語
 * en : 英語
 * ja : 日本語
 */
export const LANGUAGE: { [key: string]: string } = {
  en: 'LBL_LANG_EN',
  ja: 'LBL_LANG_JA',
};
/** パートナーカンパニーとして設定可能な上限 */
export const MAX_COUNT_PARTNER_COMPANY = 5;
/** 新しい組織を作成する時、デフォルトで表示されるパートナーカンパニーの数 */
export const DEFAULT_COUNT_PARTNER_COMPANY = 0;
/** 診断区分と表示文言の紐付け */
export const INSPECTION_CLASS: { [key: number]: string } = {
  1: 'LBL_STATUS_INSPECTION',
  2: 'LBL_STATUS_QC',
};
/** テンプレート区分と表示文言の紐付け */
export const TEMPLATE_CLASS: { [key: number]: string } = {
  1: 'LBL_FULL_INSPECTION',
  2: 'LBL_SIMPLE_INSPECTION',
};
/** API連携時のソートの昇順/降順の文字列 */
export const ORDER_TEXT = {
  /** 昇順 */
  ASC: 'asc',
  /** 降順 */
  DESC: 'desc',
} as const;
/** 日付文字列のフォーマット */
export const DATE_FORMAT: { [key: number]: string } = {
  0: 'YYYY-MM-DD',
  1: 'MM-DD-YYYY',
  2: 'DD-MM-YY',
};
/** InspeXの各画面のURL */
export const INSPEX_PATHNAME = {
  /** 修理依頼検索 */
  RMA_SEARCH: '/',
  /** ログイン */
  LOGIN: '/Login',
  /** シリアルチェック */
  SERIAL_CHECK: '/SerialCheck',
  /** 診断TOP */
  INSPECTION_TOP: '/InspectionTop',
  /** 診断 */
  INSPECTION: '/Inspection/',
  /** 入力結果確認 */
  INSPECTION_INPUT_RESULT: '/InputResult',
  /** 確定診断 */
  CONFIRMED_INSPECTION: '/ConfirmedInspection',
  /** 確定診断QC */
  CONFIRMED_QC: '/ConfirmedQc',
  /** パーツ選択 */
  PARTS_SELECTION: '/PartsSelection',
  /** 帳票 */
  REPORT: '/Report',
  /** 診断項目管理 */
  MANAGE_INSPECTION_ITEM: '/ManageInspectionItem',
  /** 診断基準管理 */
  MANAGE_CRITERIA: '/ManageCriteria',
  /** テンプレート管理 */
  MANAGE_TEMPLATE: '/ManageTemplate',
  /** ユーザー管理 */
  MANAGE_USER: '/ManageUser',
  /** 組織管理 */
  MANAGE_ORGANIZATION: '/ManageOrganization',
  /** 帳票プレビュー */
  REPORT_FORMAT: '/ReportFormat',
  /** マスター管理 */
  MANAGE_CODE_MASTER: '/ManageCodeMaster',
  /** 操作履歴管理 */
  MANAGE_HISTORY: '/ManageHistory',
} as const;
/** 各画面とそれを表示可能な修理依頼のステータスのMap */
export const PATHNAME_STATUS_MAP: Record<string, number[]> = {
  [INSPEX_PATHNAME.SERIAL_CHECK]: [
    INSPECTION_STATUSES.INSPECTION_SERIAL_CHECK,
    INSPECTION_STATUSES.INSPECTION_COMPLETE,
    INSPECTION_STATUSES.QC_REPAIRING,
  ], // 110, 180, 230
  [INSPEX_PATHNAME.INSPECTION_TOP]: [
    INSPECTION_STATUSES.INSPECTION_IN_PROGRESS,
    INSPECTION_STATUSES.QC_IN_PROGRESS,
  ], // 120, 210
  [INSPEX_PATHNAME.INSPECTION]: [
    INSPECTION_STATUSES.INSPECTION_IN_PROGRESS,
    INSPECTION_STATUSES.QC_IN_PROGRESS,
  ], // 120, 210
  [INSPEX_PATHNAME.INSPECTION_INPUT_RESULT]: [
    INSPECTION_STATUSES.INSPECTION_INPUT_RESULT,
  ], // 130
  [INSPEX_PATHNAME.CONFIRMED_INSPECTION]: [
    INSPECTION_STATUSES.INSPECTION_CONFIRM,
  ], // 140
  [INSPEX_PATHNAME.PARTS_SELECTION]: [
    INSPECTION_STATUSES.INSPECTION_PARTS_SELECT,
  ], // 220
  [INSPEX_PATHNAME.REPORT]: [
    INSPECTION_STATUSES.INSPECTION_NOT_LINKED,
    INSPECTION_STATUSES.NO_FAULT_FOUND,
    INSPECTION_STATUSES.INSPECTION_COMPLETE,
    INSPECTION_STATUSES.QC_IN_PROGRESS,
    INSPECTION_STATUSES.QC_REPAIRING,
    INSPECTION_STATUSES.QC_NOT_LINKED,
    INSPECTION_STATUSES.QC_COMPLETE,
    INSPECTION_STATUSES.QC_CONFIRM,
  ], // 160, 170, 180, 210, 220, 230, 240, 250
  [INSPEX_PATHNAME.CONFIRMED_QC]: [INSPECTION_STATUSES.QC_CONFIRM], // 220
};
/** 有効桁数 */
export const VALID_NUMBER_DIGITS: { [key: string]: number } = {
  THREE: 3,
  FOUR: 4,
};
/** 有効年範囲 */
export const VALID_YEAR_RANGE: { [key: string]: number } = {
  MIN: 1900,
  MAX: 2099,
};
/** 診断項目の階層の最小、最大値 */
export const VALID_DEPTH = {
  MIN: 0,
  MAX: 2,
};
/** 診断項目に紐づく属性の条件文字列 */
export const VALID_ATTRIBUTE_CONDITION = ['AND', 'OR'];
/** 質問の回答(ExFM連携用に合わせる) */
export const ANSWER_VALUE = {
  YES: '1',
  NO: '2',
};
/** ExFMを開く際の遷移先画面のパス */
export const EXFM_PATH = {
  DETAIL: '/page/repairDetail.jsp',
  PARTS: '/page/repairParts.jsp',
  QC: '/page/repairQc.jsp',
};
/** ExFMのURLに付与するクエリパラメータ */
export const EXFM_QUERY_PARAM = {
  /** 修理依頼番号 */
  RMA_NO: 'repair_id',
};
/** 画像取得失敗時の共通文字列 */
export const PARTS_LIST_IMAGE = {
  LOADING: 'loading',
  ERROR: 'error',
};
// ドラッグ中のマウスの開始位置とスクロール位置を保持するための初期値
export const DEFAULT_DRAG_INFO = { x: 0, scrollLeft: 0, isMoving: false };
/** クリックとドラッグの閾値(px) */
export const CLICK_DRAG_THRESHOLD = 10;
